<div class="relative py-2 mb-32 lg:mb-16">
    <div class="flex items-center gap-4 flex-wrap">

        <!-- CREATED -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.CREATED | enumLabel"
                    [severity]="SampleState.CREATED | sampleStateSeverity"
            ></p-tag>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- PUBLISHED -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.PUBLISHED | enumLabel"
                    [severity]="SampleState.PUBLISHED | sampleStateSeverity"
            ></p-tag>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- APPROVAL_REQUESTED -->
        <div class="relative flex items-center">
            <p-tag
                    [value]="SampleState.APPROVAL_REQUESTED | enumLabel"
                    [severity]="SampleState.APPROVAL_REQUESTED | sampleStateSeverity"
            ></p-tag>
            <div class="absolute flex flex-col items-center"
                 style="left: 50%; transform: translateX(-50%) translateY(35px);">
                <div class="flex items-center space-x-2">
                    <i class="pi pi-arrow-down text-gray-600"></i>
                    <i class="pi pi-arrow-up text-gray-600"></i>
                </div>
            </div>
            <!-- CHANGE_REQUESTED -->
            <div class="absolute" style="left: 50%; transform: translateX(-50%) translateY(70px);">
                <p-tag
                        [value]="SampleState.CHANGE_REQUESTED | enumLabel"
                        [severity]="SampleState.CHANGE_REQUESTED | sampleStateSeverity"
                ></p-tag>
            </div>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- APPROVED_BY_REVIEWER -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.APPROVED_BY_REVIEWER | enumLabel"
                    [severity]="SampleState.APPROVED_BY_REVIEWER | sampleStateSeverity"
            ></p-tag>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- IN_PRODUCTION -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.IN_PRODUCTION | enumLabel"
                    [severity]="SampleState.IN_PRODUCTION | sampleStateSeverity"
            ></p-tag>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- ACTIVE -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.ACTIVE | enumLabel"
                    [severity]="SampleState.ACTIVE | sampleStateSeverity"
            ></p-tag>
        </div>
        <i class="pi pi-arrow-right text-gray-600"></i>

        <!-- ARCHIVED -->
        <div class="flex items-center">
            <p-tag
                    [value]="SampleState.ARCHIVED | enumLabel"
                    [severity]="SampleState.ARCHIVED | sampleStateSeverity"
            ></p-tag>
        </div>

    </div>
</div>
